module.exports = __webpack_public_path__ + "assets/img/27_1436_big.d0d78680.jpg";